import { render } from "./ParagraphTwoColumns.vue?vue&type=template&id=83110148"
import script from "./ParagraphTwoColumns.vue?vue&type=script&lang=js"
export * from "./ParagraphTwoColumns.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__